<script>
import img from '@/assets/images/background_img_1.svg';
import img_2 from '@/assets/images/theme_2.svg';
import img_3 from '@/assets/images/theme_3.svg';
import img_4 from '@/assets/images/theme_4.svg';
import img_5 from '@/assets/images/theme_5.svg';
import img_6 from '@/assets/images/theme_6.svg';
import img_7 from '@/assets/images/theme_7.svg';
import img_8 from '@/assets/images/theme_8.svg';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    needOverflow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      img: img,
      img_2: img_2,
      img_3: img_3,
      img_4: img_4,
      img_5: img_5,
      img_6: img_6,
      img_7: img_7,
      img_8: img_8,
    };
  },
  computed: {
    themPicker: function () {
      const theme = localStorage.getItem('theme');
      switch (theme) {
        case '2':
          return this.img_2;
        case '3':
          return this.img_3;
        case '4':
          return this.img_4;
        case '5':
          return this.img_5;
        case '6':
          return this.img_6;
        case '7':
          return this.img_7;
        case '8':
          return this.img_8;
        default:
          return this.img;
      }
    },
  },
};
</script>
<template>
  <section class="page-container" dir="rtl">
    <div :style="`background-image: url(${themPicker});`" class="relative page-container-background_layer"
      :class="{ need_overflow: needOverflow }">
      <section class="page-container-header">
        <v-row no-gutters>
          <v-col cols="3">
            <slot name="title">
              <div class="page-container-header-title">
                {{ title }}
              </div>
            </slot>
          </v-col>
          <v-col cols="9">
            <v-row no-guuters>
              <slot name="header"></slot>
            </v-row>
          </v-col>
        </v-row>
      </section>
      <section class="page-container-body" :class="{ need_overflow_body: needOverflow }" dir="rtl">
        <slot name="body"></slot>
      </section>
      <section>
        <slot name="append"></slot>
      </section>
    </div>
  </section>
</template>
<style scoped lang="scss">
.page-container {
  width: 99%;
  height: 90.5vh;
  // height: calc(100vh - 70px);
  margin-right: auto;
  // margin-top: 1rem;
  margin-top: 3px;

  &-background_layer {
    background-size: cover;
    height: 100%;
    width: 100%;
  }

  &-header {
    max-height: 78px;
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1rem;
    font-weight: 500;
    color: white;

    &-title {
      transform: translate(-20px, 51%);
    }
  }

  &-body {
    padding: 0 0.5rem;
    padding-top: 5.1rem;
    flex-grow: 1;
    height: 100%;
  }
}

.need_overflow {
  display: flex;
  flex-direction: column;
}

.need_overflow_body {
  overflow-y: auto;
  overflow-x: hidden;
}

@media only screen and (max-width: 1279px) {
  .page-container {
    //width: 94%;
    width: 100%;
  }
}

@media only screen and (min-width: 1800px) {
  .page-container {
    &-header {
      max-height: 80px;
    }

    &-body {
      padding: 0 0.5rem;
      padding-top: 6.3rem;
    }
  }
}
</style>
